import Image from 'next/image';

import buySellLockInRate from '@/assets/images/buySellLockInRate.svg';
import cashTrust from '@/assets/images/cashTrust.svg';
import onlinePaymentWallet from '@/assets/images/onlinePaymentWallet.svg';
import onlineProfile from '@/assets/images/onlineProfile.svg';

const SendMoneySteps = () => {
  return (
    <section className="step_to_get_forex">
      <div className="container">
        <h2 className="text--black text--bold section__title-small step-text text-center">
          4 Easy Steps to Get Forex
        </h2>
        <div className="row">
          <div className="col-lg-3">
            <div className="mb-lg-0  step-box">
              <Image
                style={{ color: undefined }}
                className="img-fluid"
                src={buySellLockInRate}
                alt="vision icon"
              />
              <p className="text--bold text--black title">STEP 1</p>
              <p className="text--gray text--regular desc step_detail">
                Choose a currency & lock- your prices
              </p>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="mb-lg-0 step-box">
              <Image
                style={{ color: undefined }}
                className="img-fluid"
                src={onlineProfile}
                alt="mission icon"
              />
              <p className="text--bold text--black title">STEP 2</p>
              <p className="text--gray text--regular desc step_detail">
                Complete your profile online or at a nearby Muthoot FinCorp
                branch
              </p>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="mb-lg-0 step-box  mb-0">
              <Image
                style={{ color: undefined }}
                className="img-fluid"
                src={onlinePaymentWallet}
                alt="values icon"
              />
              <p className="text--bold text--black title">STEP 3</p>
              <p className="text--gray text--regular desc step_detail">
                Make a payment online or at the branch to confirm your money
                transfer
              </p>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="mb-lg-0 step-box  mb-0">
              <Image
                style={{ color: undefined }}
                className="img-fluid"
                src={cashTrust}
                alt="values icon"
              />
              <p className="text--bold text--black title">STEP 4</p>
              <p className="text--gray text--regular desc step_detail">
                Money gets credited to the beneficiary account in 24 hours*
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default SendMoneySteps;
